"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var colors_1 = require("../colors");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    basePoppins: {
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        textTransform: 'none',
        color: function (props) { return (props.color ? (0, colors_1.getColor)(props.color) : 'inherit'); },
    },
    titleH1: {
        fontSize: '40px',
        fontWeight: 700,
        lineHeight: '60px',
    },
    titleH2: {
        fontSize: '32px',
        fontWeight: 700,
        lineHeight: '48px',
    },
    titleH3: {
        fontSize: '24px',
        fontWeight: 700,
        lineHeight: '36px',
    },
    titleH4: {
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: '30px',
    },
    titleH4Semibold: {
        fontSize: '20px',
        fontWeight: 600,
        lineHeight: '30px',
    },
    subtitleBold: {
        fontSize: '18px',
        fontWeight: 700,
        lineHeight: '26px',
    },
    subtitleSemibold: {
        fontSize: '18px',
        fontWeight: 600,
        lineHeight: '26px',
    },
    subtitle: {
        fontSize: '18px',
        fontWeight: 400,
        lineHeight: '26px',
    },
    body: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px',
    },
    bodyMedium: {
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '24px',
    },
    bodySemibold: {
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '24px',
    },
    bodyBold: {
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: '24px',
    },
    small: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
    },
    smallMedium: {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px',
    },
    smallSemibold: {
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: '20px',
    },
    label: {
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '18px',
    },
    labelSemibold: {
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '18px',
    },
}); });
var Text = function (_a) {
    var children = _a.children, className = _a.className, color = _a.color, variant = _a.variant, props = __rest(_a, ["children", "className", "color", "variant"]);
    var classes = useStyles({ color: color });
    // const setHtmlElement = (children: ReactNode, variant: Variant, color?: ColorType): JSX.Element => {
    //   switch (variant) {
    //     case 'titleH1':
    //       return <h1 style={{ color: color ? getColor(color) : 'inherit' }}>{children}</h1>;
    //     case 'titleH2':
    //       return <h2 style={{ color: color ? getColor(color) : 'inherit' }}>{children}</h2>;
    //     case 'titleH3':
    //       return <h3 style={{ color: color ? getColor(color) : 'inherit' }}>{children}</h3>;
    //     case 'titleH4':
    //       return <h4 style={{ color: color ? getColor(color) : 'inherit' }}>{children}</h4>;
    //     default:
    //       return <p style={{ color: color ? getColor(color) : 'inherit' }}>{children}</p>;
    //   }
    // };
    return (react_1.default.createElement("div", __assign({ className: (0, clsx_1.default)(classes.basePoppins, classes[variant], className) }, props), children));
};
exports.Text = Text;
